import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FilterFactory, ICriteria } from '../models/filter-factory.interface';
import { IFilter, IFilterOperator } from '../models/filter.interface';

@Component({
  selector: 'app-filter-creator',
  templateUrl: './filter-creator.component.html',
  styleUrls: ['./filter-creator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterCreatorComponent implements OnInit {
  @Input() filterFactories: FilterFactory[] = [];
  @Output() filterCreated = new EventEmitter<IFilter>();

  get selectedFactory(): FilterFactory | undefined {
    if (this.isFactorySelected) {
      return this.filterForm.value.field;
    }

    return undefined;
  }

  get operators(): IFilterOperator[] {
    if (!this.isFactorySelected) {
      return [];
    }

    return this.selectedFactory!.operators!;
  }

  get criterias(): ICriteria[] | undefined {
    if (!this.isFactorySelected) {
      return undefined;
    }

    return this.selectedFactory!.criterias;
  }

  get isFactorySelected(): boolean {
    return !!this.filterForm.value.field;
  }

  filterForm = new FormGroup({
    field: new FormControl('', [Validators.required]),
    operator: new FormControl('', [Validators.required]),
    criteria: new FormControl('', [Validators.required])
  });

  constructor() { }

  ngOnInit(): void {
  }

  createFilter(): void {
    const { operator, criteria } = this.filterForm.value;
    this.selectedFactory!.selectedOperator = operator;
    this.selectedFactory!.selectedCriteria = criteria;

    this.filterCreated.emit(
      this.selectedFactory!.build()
    );

    this.filterForm.reset();

  }
}
